import React from 'react';
import AppLayout from '../components-app/AppLayout';
import OverviewList from '../components-static/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,MobileMenu} from '../components-static/Common';
import {EditSizeLabel,EditableBox,EditableSelect,Box,Select,TextButton,Button} from '../components-static/Input';
import u from '../utilities/Utilities';
import {BlockOptions} from '../data/Options';
import PropTypes from 'prop-types';
import {Spreadsheet} from '../data/Mimetypes';
import '../styles/staff-list.scss';
import moment from 'moment';

export default class TenantList extends React.Component{

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        spreadsheetOptions:[],
        addError:"",
        permissions:{},
        selectMode:false,
    };

    pageData={
        title:"Tenants (Company)",
        permission:"tenant",
        url:"/tenant-list",
        scrollAnchor:u.getKey(),
    };

    listData={
        deleteURL:"/api/delete-tenant-entries",
        spreadsheetURL:"/api/generate-tenant-spreadsheet",
        overviewURL:"/api/get-all-tenant",
        overviewLabel:"tenant-list",
        orderByField:"tenantName",
        orderByType:"ascending",
        numRows:20,
        checkboxPermissions:{},
        listOptions:[
            {label:"Tag Setting",ref:"macro",enabled:true,type:"list"},
        ]
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("tenant");
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add", mobileLabel:"Add User",ref:"add",image:"/images/page-menu/add.png",title:"Add new tenant",enabled:(permissions.create==2)},
                {label:"Template", mobileLabel:"Download Template",ref:"download",image:"/images/page-menu/template.png",title:"Download bulk add template",enabled:(permissions.create==2),onClick:this.onDownloadTemplate},
                {label:"Delete", mobileLabel:"Delete User",ref:"delete",image:"/images/page-menu/delete.png",title:"Delete selected tenant",enabled:(permissions.delete==2)},
                {label:"Spreadsheet", mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:true},
            ]
        })
    };

    onMenuOptionClicked=(ref,show,mobileNav)=>{
        if(mobileNav){
            const toggle = (this.mobileSelect != ref);
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && toggle)});
            this.mobileSelect= ((toggle) ? ref : null);
            for(var i=0; i<mobileNav.length; i++){
                const r = mobileNav[i].ref;
                const show = (r == ref);

                if(show){
                    if(mobileNav[i].onClick){
                        mobileNav[i].onClick();
                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,toggle);
                    }
                    else{
                        this.refs[r].show(toggle);
                    }
                }
                else{
                    if(mobileNav[i].onClick) {

                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,false);
                    }
                    else{
                        this.refs[r].show(false);
                    }
                }
            }
        }
        else{
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && show)});
            this.refs[ref].show(show);
        }
    };

    onToggleForm=(ref,show)=>{
        this.refs['menu'].toggleForm(ref,show);
        this.mobileSelect=(show) ? ref : null;
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onRefreshList=()=>{
        this.refs['overview'].onRefreshList();
    };

    onContentGrabbed=(content)=>{
        this.setState({spreadsheetOptions:content.spreadsheetOptions});
    };

    onDownloadTemplate=()=>{
        u.post({
            url:"/api/get-add-tenant-template",
            data:{},
            success:(callback)=>{
                u.download(callback.filename,callback.filestamp, ()=>{},
                (error,status)=>{
                    console.log(error);
                    this.setState({error:error});
                });
            },
            error:(error,status)=>{
                this.setState({error:error});
            }
        })
    };

    render=()=>{
        const mobileMenu = this.state.pageMenuButtons.concat(this.listData.listOptions);
        console.log('permissions: ', this.state.permissions);
        return (
            <AppLayout ref="layout" title={this.pageData.title} requiredPermission={this.pageData.permission} url={this.pageData.url}>
                <div className="page-error">{this.state.error}</div>
                <PageMenu id={this.pageData.scrollAnchor} title={this.pageData.title} ref="menu" buttons={this.state.pageMenuButtons} onMenuOptionClicked={this.onMenuOptionClicked}>
                    <AddEntry scrollAnchor={this.pageData.scrollAnchor} ref="add" reference="add" onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <DeleteListItem scrollAnchor={this.pageData.scrollAnchor} ref="delete" reference="delete" url={this.listData.deleteURL} selected={this.state.selected} onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <GenerateSpreadsheet scrollAnchor={this.pageData.scrollAnchor} ref="spreadsheet" url={this.listData.spreadsheetURL} options={this.state.spreadsheetOptions} reference="spreadsheet" selected={this.state.selected} onToggleForm={this.onToggleForm}/>
                </PageMenu>
                <OverviewList ref="overview" selectMode={this.state.selectMode} url={this.listData.overviewURL} label={this.listData.overviewLabel} numRows={this.listData.numRows} orderByField={this.listData.orderByField} orderByType={this.listData.orderByType} onSelectChange={this.onSelectChange} registerReference={this.registerReference} onContentGrabbed={this.onContentGrabbed} onMutatedChange={this.onMutatedChange} checkboxPermissions={this.listData.checkboxPermissions}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <TenantItem key={index}
                                            index={index}
                                            content={content}
                                            onChange={onChange}
                                            onContentChange={onContentChange}
                                            registerReference={registerRef}
                                            permissions={this.state.permissions}
                                            triggerPopup={this.refs['layout'].onPopup}
                                            />
                            )
                        }
                    }
                </OverviewList>
                <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked}/>
            </AppLayout>
        )
    }
}

class TenantItem extends React.Component{

    state={
        error:""
    };

    render=()=>{
        const content = this.props.content;
        const edit = (this.props.permissions.update == 2);
        const url = "/api/update-tenant-info";
        const index = this.props.index+""
        const id = content.tenantID;

        return (
            <div style={{textAlign:"center"}}>

                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Tenant:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Tenant" field="tenantName" values={{value:content.tenantName,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Unit:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Unit" field="unit" values={{value:content.unit,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Level:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Level" field="level" values={{value:content.level,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Block:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Block" field="block" values={{value:content.block,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Status:</div>
                        <div className="list-segment-input">
                            <EditableSelect label="Status"
                                            field="status"
                                            values={{value:content.status,enabled:edit,options:[{value:"Active",label:"Active"},{value:"Inactive",label:"Inactive"}]}}
                                            rules={{required:true,confirm:{title:"Confirm Status Change?",description:"Changing tenant status will enable or disable web, app & turnstile access to all of the tenant's users",triggerPopup:this.props.triggerPopup}}}
                                            id={id}
                                            index={index}
                                            url={url}
                                            onChange={this.props.onChange}
                                            />
                        </div>
                    </div>
                </div>

                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Contact Person:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Contact Person" field="contactPerson" values={{value:content.contactPerson,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Contact Number:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Contact Number" field="contactNumber" values={{value:content.contactNumber,enabled:edit}} rules={{nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Email:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Email" field="email" type="email" values={{value:content.email,enabled:edit}} rules={{required:true,nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Active Staff:</div>
                        <div className="list-segment-input"><EditSizeLabel>{(content.activeStaff) ? content.activeStaff : "None"}</EditSizeLabel></div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Total Staff:</div>
                        <div className="list-segment-input"><EditSizeLabel>{(content.totalStaff) ? content.totalStaff : "None"}</EditSizeLabel></div>
                    </div>
                </div>

            </div>
        )
    }
}

class AddEntry extends React.Component{

    state={
        error:"",
        entryData:{}
    };

    addData={
        addType:0,
        addURL:"/api/add-tenant",
        bulkAddURL:"/api/add-bulk-tenant"
    };

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    onChangeEntry=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onAddEntry=()=>{
        this.setState({error:""});
        const inputs = ['tenantName','unit',"level","block",'email','contactNumber','contactPerson'];
        for(var i=0; i<inputs.length; i++){
            const current = this.refs[inputs[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }

        this.refs[this.props.reference].onValidated(this.state.entryData);
    };

    onComplete=()=>{
        this.setState({error:"",entryData:{}});
    };

    render=()=>{
        const content=this.state.entryData;
        return (
            <AddListItem scrollAnchor={this.props.scrollAnchor} ref={this.props.reference}
                         reference={this.props.reference} addType={this.addData.addType}
                         index={this.addData.addIndex} label={this.addData.label} bulkURL={this.addData.bulkAddURL}
                         filetypes={Spreadsheet} url={this.addData.addURL} onToggleForm={this.props.onToggleForm}
                         onRefreshList={this.props.onRefreshList} onComplete={this.onComplete}>
                <div style={{textAlign:"center"}}>
                    <h3>Complete the following to continue</h3>
                    <div className="segment-error">{this.state.error}</div>
                    <div className="segment-content">
                        <div className="segment-margin-area">
                            <div className="segment-full-item">
                                <div className="segment-item-label">Tenant Name:</div>
                                <div className="segment-item-input">
                                    <Box ref="tenantName" label="Tenant Name" field="tenantName" values={{value:content.tenantName}} rules={{required:true}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Unit:</div>
                                <div className="segment-item-input">
                                    <Box ref="unit" label="Unit" field="unit" values={{value:content.unit}} rules={{required:true}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Level:</div>
                                <div className="segment-item-input">
                                    <Box ref="level" label="Level" field="level" values={{value:content.level}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Block:</div>
                                <div className="segment-item-input">
                                    <Select ref="block" label="Block" field="block" values={{value:content.block,options:BlockOptions}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Email:</div>
                                <div className="segment-item-input">
                                    <Box ref="email" label="Email" type="email" field="email" values={{value:content.email}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Contact Number:</div>
                                <div className="segment-item-input">
                                    <Box ref="contactNumber" label="Contact Number" field="contactNumber" values={{value:content.contactNumber}} rules={{placeholder:"Optional",mobileNumber:true}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Contact Person:</div>
                                <div className="segment-item-input">
                                    <Box ref="contactPerson" label="Contact Person" field="contactPerson" values={{value:content.contactPerson}} rules={{placeholder:"Optional"}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                        </div>

                        <div className="segment-margin-area" style={{fontSize:"0.9em"}}>
                            <TextButton onClick={()=>{this.refs[this.props.reference].onBulkUpload()}}>Add Bulk Entries</TextButton>
                        </div>

                        <div className="segment-margin-area">
                            {
                                (u.isMobileDevice())
                                ?
                                <Button type="medium" onClick={()=>{this.props.onToggleForm(this.props.reference,false)}}>Cancel</Button>
                                :
                                ""
                            }
                            <Button type="medium" onClick={this.onAddEntry}>Add Entry</Button>
                        </div>
                    </div>
                </div>
            </AddListItem>
        )
    }
}
AddEntry.propTypes={
    scrollAnchor:PropTypes.string,
    onToggleForm:PropTypes.func.isRequired,
    onRefreshList:PropTypes.func.isRequired,
};
